import React from "react";
import { DeploymentRequestListPageInitialState, PageNewState } from ".";

export const DeploymentRequestListPageContext = React.createContext({
  pageState: DeploymentRequestListPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
